"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.draftValidationSchema = void 0;
const yup_1 = require("yup");
const draft_js_1 = require("draft-js");
(0, yup_1.addMethod)(yup_1.string, "draftHasText", function (errorMessage) {
    return this.test(`draft-has-text`, errorMessage, function (value) {
        const { path, createError } = this;
        const contentState = draft_js_1.EditorState.createWithContent((0, draft_js_1.convertFromRaw)(JSON.parse(value)));
        const hasText = contentState.getCurrentContent().hasText();
        return hasText || createError({ path, message: errorMessage });
    });
});
exports.draftValidationSchema = (0, yup_1.string)()
    .required("form.validations.valueMissing")
    .draftHasText("form.validations.valueMissing");
//# sourceMappingURL=draft-has-test.js.map